import React from 'react'
import styled from "styled-components"
import emailjs from "emailjs-com"

const Wrapper = styled.div`
margin-top:25vh;
.form{
    display:flex;
    flex-direction:column;
    justify-contennt:center;
    align-items:center;
    padding:5px;    
textarea{
        width:33%;
        height:300px;
        font-size:21px;
        color:black;
        border:1px solid blueviolet;
        border-radius:5px;
        background-color:#cccccc;
        &:hover{
            border:1px solid black;
        }
    @media (max-width:360px){
        width:300px;
    }
    @media (max-width:640px){
        width:300px;
    }
}

}
input[type="text"]{
    width:33%;
    height:50px;
    margin-bottom:20px;
    text-indent:20px;
    border-radius:5px;
    outline:none;
    border:1px solid blueviolet;
    background-color:#cccccc;
    ::placeholder{
        font-size:21px;
    }    
    &:hover{
        border:1px solid black;
    }
    @media (max-width:360px){
        width:300px;
    }
    @media (max-width:640px){
        width:300px;
    }
}
input[type="submit"]{
    width:200px;
    height:50px;
    margin-top:20px;
    
    background-color:blueviolet;
    border-radius:5px;
    font-weight:bold;
    border:none;
    color:white;
    &:hover{
        background-color: white;
        border:1px solid black;
        color:black;
    }
    &:focus{
        opacity:0.5;
    }
}


`

const Contact = () => {

    const [ name, setName ] =React.useState("")
    const [ email, setEmail ] =React.useState("")
    const [ message, setMessage ] =React.useState("")
    
    console.log(process.env.REACT_APP_USER_ID,"secret")
    let templateId = process.env.REACT_APP_TEMPLATE_ID
    let userId = process.env.REACT_APP_USER_ID
    let serviceId = process.env.REACT_APP_SERVICE_ID
    

    const sendEmail = (e)=> {
        e.preventDefault();
        
       if(name !=="" && email !=="" && message !=="")
       {

        emailjs.sendForm("service_8ihvpqq", "template_rhqcl7d", e.target, "user_65EA2g6SS1KLHbpaD3wJb")
        .then((result) => {
            console.log(result.text);
            alert("Sent")
        }, (error) => {
            console.log(error.text);
            alert("Error ocurred")
        });
       }
       else{
           alert("Please fill all the fields")
       }
      }
    return (<>

            <Wrapper id="contact">
                <form className="form" onSubmit={ sendEmail }>
                    <h1>Contact Me</h1>
                    <input type="text" name="name" placeholder="Full Name" value={ name } onChange={(e)=>setName(e.target.value)}/>
                    <input type="text" name="email" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                    <textarea name="message" placeholder="Write message here to Aejaz..." value={ message } onChange={(e)=>setMessage(e.target.value)}>  
                    </textarea>
                    <input type="submit" value="SEND MESSAGE"/>
                </form>
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <p style={{fontSize:"12px"}}>&copy;<time  dateTime="2001-05-15T19:00">2021</time> copyright Aejaz Ahmed.</p>
                </div>
            </Wrapper>
        
    </>)
}

export { Contact }

